<template>
  <v-layout class="fontlao">
    <v-main>
      <router-view />
      <LoadingOverlay v-if="loading" />
      <SnackbarSuccess v-if="alertSucces" />
      <SnackbarFailed v-if="alertFail" />
    </v-main>
  </v-layout>
</template>

<script>
import { useDisplay } from "vuetify";
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import LoadingOverlay from "../alert/loading-overlay.vue";
import SnackbarFailed from "../alert/Snackbar-Failed.vue";
import SnackbarSuccess from "../alert/Snackbar-Success.vue";
import { useRouter } from "vue-router";
export default {
  components: {
    LoadingOverlay,
    SnackbarSuccess,
    SnackbarFailed,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const drawer = ref(null);
    const hideMenu = ref(true);
    const hideImg = ref(true);
    const { width } = useDisplay();

    watch(width, (width) => {
      responsive(width);
    });

    onMounted(() => {
      // store.dispatch("authPageModule/getUserMain");
      responsive(width.value);
    });

    const responsive = (width) => {
      if (width < 940) {
        hideMenu.value = false;
      } else {
        hideMenu.value = true;
      }

      if (width < 1200) {
        hideImg.value = false;
      } else {
        hideImg.value = true;
      }
    };

    const logout = () => {
      store.dispatch("authPageModule/logout");
    };

    return {
      router,
      logout,
      drawer,
      hideMenu,
      hideImg,
    };
  },
  computed: {
    alertSucces: {
      get() {
        return this.$store.state.snackbarSuccess;
      },
    },
    alertFail: {
      get() {
        return this.$store.state.snackbarFailed;
      },
    },
    loading: {
      get() {
        return this.$store.state.LoadingOverlay;
      },
    },
  },
};
</script>

<style>
.fontlao {
  font-family: phetsarath ot !important;
}
.f-color {
  color: white;
}
</style>
